export default __webpack_public_path__ + "static/media/mlr-1-rMIN.97cb1a2f.avif";